import { Indicator, IndicatorState } from '@cue/atoms';
import { ShowroomTopics } from '@project/cue-api/virtual-experience/fetch-video-story-topics';
import { RefObject, forwardRef, useEffect, useMemo, useState } from 'react';
import { Helmet } from 'react-helmet';
import { useTranslation } from 'react-i18next';

export const VirtualExperienceFilterMenu = forwardRef(function VirtualExperienceFilterMenu(
  props: VirtualExperienceTopicsMenuProps,
  ref: React.ForwardedRef<HTMLDivElement>,
) {
  /* export const VirtualExperienceFilterMenu = (props: VirtualExperienceTopicsMenuProps) => {
   */ const { videoTopicsJSON, visible, wrapperRef } = props;
  const {
    i18n: { language },
  } = useTranslation();

  const [active, setActive] = useState('');

  const masterTopics = useMemo(
    () =>
      videoTopicsJSON?.map((topic) => {
        return {
          title: topic.translations?.find((trans) => trans.language === language)?.title || '',
          id: topic.id,
          slug: topic.slug,
        };
      }),
    [language, videoTopicsJSON],
  );

  useEffect(() => {
    if (wrapperRef?.current) wrapperRef.current.setAttribute('data-topic', active);
  }, [active, wrapperRef]);

  return (
    <div
      className={`cue-video-story-filter-menu ? ${
        visible ? 'cue-video-story-filter-menu-visible' : ''
      }`}
      ref={ref}>
      <Helmet
        style={masterTopics?.map(({ id }) => ({
          cssText: `.virtual-experience.is-home[data-topic="${id}"]{
          .cue-button-videoStory:not([data-topic="${id}"]){
           display:none;    
          }
         
      }`,
        }))}
      />

      {masterTopics.map((mt) => (
        <VirtualExperienceFilterMenuItem key={mt.id} {...mt} active={active} onChange={setActive} />
      ))}
      <VirtualExperienceFilterMenuItem id="" slug="all" active={active} onChange={setActive} />
    </div>
  );
});

export const VirtualExperienceFilterMenuItem = (props: VirtualExperienceFilterMenuItemProps) => {
  const { slug, active, id, onChange } = props;
  const { t } = useTranslation();
  return (
    <div className="cue-video-story-filter-menu-item" onClick={() => onChange(id)}>
      <Indicator state={active === id ? IndicatorState.ACTIVE : IndicatorState.DEFAULT} />
      {t(`virtual-experience.filter.${slug}`)}
    </div>
  );
};

interface VirtualExperienceFilterMenuItemProps {
  id: string;
  slug: string;
  active: string;
  onChange(id: VirtualExperienceFilterMenuItemProps['id']): void;
}

interface VirtualExperienceTopicsMenuProps {
  videoTopicsJSON: ShowroomTopics[];

  visible: boolean;
  onHideMenu(): void;
  wrapperRef?: RefObject<HTMLDivElement>;
}
